var moduleMap = {
	"./TermFormBuilder": () => {
		return Promise.all([__webpack_require__.e(7262), __webpack_require__.e(4183), __webpack_require__.e(1488), __webpack_require__.e(7058), __webpack_require__.e(977), __webpack_require__.e(6122), __webpack_require__.e(5676), __webpack_require__.e(4061), __webpack_require__.e(1909), __webpack_require__.e(7501), __webpack_require__.e(7403), __webpack_require__.e(10)]).then(() => (() => ((__webpack_require__(89663)))));
	},
	"./FingerprintCapture": () => {
		return Promise.all([__webpack_require__.e(1488), __webpack_require__.e(7058), __webpack_require__.e(6122), __webpack_require__.e(5676), __webpack_require__.e(4061), __webpack_require__.e(1909), __webpack_require__.e(7501), __webpack_require__.e(7403), __webpack_require__.e(3874)]).then(() => (() => ((__webpack_require__(70484)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});